import React from "react";
import { Icon } from "react-feather";
import styled from "styled-components";
import Button from "../Buttons/Button";
import { Link } from "gatsby";

const StyledCard = styled.div`
  /* text-decoration: none; */
  display: flex;
  height: 100%;
  padding: 1em;
  font-size: var(--fz-sm);
  flex-direction: column;
  justify-content: space-between;
  border: var(--border-width-hard) solid ${({ theme }) => theme.colors.dborder};
  transform: translateZ(0);
  transition: all 0.4s ease;
  box-sizing: border-box;
  cursor: pointer;
  font-family: "Poppins";
  font-weight: 400;
  color: ${({ theme }) => theme.colors.descfont};

  h1 {
    font-size: var(--fz-xl);
    font-family: var(--font-serif-ogg);
    font-weight: 500;
    /* margin: 0.4em 0 0 0; */
    line-height: 1.1em;
    color: ${({ theme }) => theme.colors.primary};
  }

  .desc {
    color: ${({ theme }) => theme.colors.descfont};
    font-size: var(--fz-sm);
    font-weight: 400;
  }

  .footer {
    ${({ theme }) => theme.mixins.flex.flexBetween};
  }

  @media (min-width: 400px) {
    font-size: var(--fz-md);
    /* h1 {
      font-size: var(--fz-xxxl);
    } */
  }

  @media (min-width: 800px) {
    padding: 1.5em;
    .desc {
      font-size: var(--fz-md);
    }
    h1 {
      font-size: var(--fz-xxl);
    }
  }

  :hover {
    border: var(--border-width-hard) solid
      ${({ theme }) => theme.colors.dborder};
  }
`;

const HorizonalCard = ({
  title,
  desc,
  btnName,
  btnIcon,
  btnLink,
  cardLink,
}: {
  title: string | React.ReactNode;
  desc?: string | React.ReactNode;
  btnName?: string;
  btnIcon?: Icon;
  btnLink?: string;
  cardLink?: string;
  footertext?: string;
  footerlink?: string;
}) => {
  if (cardLink) {
    return (
      <Link to={cardLink ?? ""}>
        <StyledCard>
          <div className="content">
            <h1>{title}</h1>
            <div className="desc">{desc}</div>
          </div>
          <div className="footer">
            {btnLink && <Button link={btnLink} name={btnName} Icon={btnIcon} />}
            {/* {footertext && <a href={footerlink}>{footertext}</a>} */}
          </div>
        </StyledCard>
      </Link>
    );
  } else {
    return (
      <StyledCard>
        <div className="content">
          <h1>{title}</h1>
          <div className="desc">{desc}</div>
        </div>
        <div className="footer">
          {btnLink && <Button link={btnLink} name={btnName} Icon={btnIcon} />}
          {/* {footertext && <a href={footerlink}>{footertext}</a>} */}
        </div>
      </StyledCard>
    );
  }
};

export default HorizonalCard;
